<template>
  <div class="singleSet">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <!-- 标题 -->
        <span class="font-sz24">条码模板配置</span>
        <div class="head-text">
          <el-button type="primary" @click="addSingle1 = true">新增</el-button>
        </div>
      </div>
      <!-- 表格 -->
      <div class="rygl-table">
        <el-table
          align="center"
          class="margin-20 table width100"
          v-loading="loading"
          :data="singleList"
          height="72vh"
          @selection-change="handleSelectionChange"
        >
          <!-- <el-table-column align="center" type="selection" width="55"></el-table-column> -->
          <el-table-column
            align="center"
            type="index"
            width="55"
            label="序号"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="tpst03"
            label="模板名称"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="tpst04"
            label="标题"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="tslk"
            label="自定义字段"
          ></el-table-column>
          <el-table-column align="center" prop="tpst07" label="RGB颜色">
            <template slot-scope="scope">
              <el-color-picker
                v-model="scope.row.tpst07"
                disabled
              ></el-color-picker>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="user04"
            label="创建人"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="tpst06"
            label="更新时间"
          ></el-table-column>
          <el-table-column align="center" label="操作">
            <template slot-scope="scope">
              <el-button
                size="small"
                type="primary"
                plain
                @click="UpdateList(scope.row)"
                >编辑</el-button
              >
              <el-button
                size="small"
                type="danger"
                plain
                @click="removeList(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <el-pagination
        align="center"
        class="mar-top"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagenum"
        :page-sizes="[100, 50, 10]"
        :page-size="pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
      <!-- 新建模板 -->
      <el-dialog
        :close-on-click-modal="false"
        title="新建模版"
        :rules="rules"
        center
        :visible.sync="addSingle1"
      >
        <el-form ref="ruleForm" :rules="rules" :model="addPostList">
          <el-form-item label="模版名称" prop="tpst03" label-width="80px">
            <el-input v-model="addPostList.tpst03"></el-input>
          </el-form-item>
          <el-form-item label="颜色" prop="tpst07" label-width="80px">
            <el-color-picker v-model="addPostList.tpst07"></el-color-picker>
          </el-form-item>
          <el-form-item label="二维码" prop="tpst04" label-width="80px">
            <el-input
              v-model="addPostList.tpst04"
              placeholder="请输入二维码贴纸显示的标题"
            ></el-input>
          </el-form-item>
          <el-form-item label-width="80px">
            <el-button type="primary" plain @click="addlabel">添加</el-button>
          </el-form-item>
          <el-row v-for="(i, index) in addPostList.list" :key="index">
            <el-col :span="7">
              <el-form-item label-width="60px">
                <el-input
                  v-model="addPostList.list[index].tslk04"
                  placeholder="标题"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label-width="20px">
                <el-input
                  v-model="addPostList.list[index].tslk05"
                  placeholder="内容"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" :offset="1">
              <el-form-item label>
                <el-button type="primary" plain @click="addlabel"
                  >添加</el-button
                >
                <el-button
                  type="danger"
                  plain
                  @click="
                    addPostList.list.splice(addPostList.list.length - 1, 1)
                  "
                  >删除</el-button
                >
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="2" :offset="10">
              <el-button type="primary" @click="addform('ruleForm')"
                >确定</el-button
              >
            </el-col>
            <el-col :span="2">
              <el-button type="danger" @click="addSingle1 = false"
                >取消</el-button
              >
            </el-col>
          </el-row>
        </el-form>
      </el-dialog>
      <!-- 编辑 -->
      <el-dialog
        :close-on-click-modal="false"
        title="编辑模型"
        :visible.sync="editor1"
      >
        <el-form ref="Updateform" :model="UpdateData" :rules="rules">
          <el-form-item label="模版名称" prop="tpst03" label-width="80px">
            <el-input v-model="UpdateData.tpst03"></el-input>
          </el-form-item>
          <el-form-item label="颜色" prop="tpst07" label-width="80px">
            <el-color-picker v-model="UpdateData.tpst07"></el-color-picker>
          </el-form-item>
          <el-form-item label="二维码" prop="tpst04" label-width="80px">
            <el-input
              v-model="UpdateData.tpst04"
              placeholder="请输入二维码贴纸显示的标题"
            ></el-input>
          </el-form-item>
          <el-form-item label-width="80px">
            <el-button type="primary" plain @click="Updateaddlabel"
              >添加</el-button
            >
          </el-form-item>
          <el-row v-for="(i, index) in UpdateData.list" :key="index">
            <el-col :span="7">
              <el-form-item label-width="60px">
                <el-input
                  v-model="UpdateData.list[index].tslk04"
                  placeholder="标题"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label-width="20px">
                <el-input
                  v-model="UpdateData.list[index].tslk05"
                  placeholder="内容"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" :offset="1">
              <el-form-item>
                <el-button type="primary" plain @click="Updateaddlabel"
                  >添加</el-button
                >
                <el-button type="danger" plain @click="removeUpdataList(i)"
                  >删除</el-button
                >
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="2" :offset="10">
              <el-button type="primary" @click="addUpdate('Updateform')"
                >确定</el-button
              >
            </el-col>
            <el-col :span="2">
              <el-button type="danger" @click="editor1 = false">取消</el-button>
            </el-col>
          </el-row>
        </el-form>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import {
  GetTempsetList,
  AddTempset,
  DelTempset,
  GetTempSetInfo,
  EditTempInfo,
  EditTempsetLink,
  AddTempsetLink,
  DelTempsetLink,
} from "@/setAxios.js";
export default {
  name: "singleSet",
  data() {
    return {
      loading: false,
      addSingle1: false,
      editor1: false,
      editorPost1: false,
      total: 0,
      pagesize: 10,
      pagenum: 1,
      editorPostList: { user01: "我是你爹" },
      // 编辑表单
      UpdateData: {},
      // 新增表单
      addPostList: {
        tpst02: localStorage.getItem("xid"),
        tpst03: "",
        tpst04: "",
        tpst05: localStorage.getItem("id"),
        tpst06: new Date(),
        tpst07: "",
        list: [
          {
            tslk02: localStorage.getItem("xid"),
            tslk04: "",
            tslk05: "",
          },
        ],
      },
      singleList: [],
      rules: {
        tpst03: [
          { required: true, message: "请输入模板名称", trigger: "blur" },
        ],
        tpst04: [
          { required: true, message: "请输入二维码标题", trigger: "blur" },
        ],
        tpst07: [{ required: true, message: "请选择颜色", trigger: "blur" }],
      },
    };
  },
  methods: {
    // 删除列表
    removeList(row) {
      this.$confirm("是否删除该模板配置?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            tempid: row.tpst01,
            xid: localStorage.getItem("xid"),
          };
          DelTempset(params).then((res) => {
            //(res);
            if (res.Code == 1) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.getData();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 编辑内容
    UpdateList(row) {
      this.editor1 = true;
      let params = {
        tid: row.tpst01,
      };
      GetTempSetInfo({ params }).then((res) => {
        //(res);
        this.UpdateData = res.Data;
        //(this.UpdateData);
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.pagenum = val;
      this.getData();
    },
    // 新增添加列表
    addlabel() {
      this.addPostList.list.push({ tslk02: localStorage.getItem("xid") });
    },
    // 编辑添加列表
    Updateaddlabel() {
      let params = JSON.stringify({
        tslk02: this.UpdateData.tpst02,
        tslk03: this.UpdateData.tpst01,
        tslk04: "",
        tslk05: "",
      });
      AddTempsetLink({ model: params }).then((res) => {
        if (res.Code == 1) {
          let params = {
            tid: this.UpdateData.tpst01,
          };
          GetTempSetInfo({ params }).then((res) => {
            //(res);
            this.UpdateData = res.Data;
            //(this.UpdateData);
          });
        }
      });
    },
    // 编辑确定按钮
    addUpdate(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            tid: this.UpdateData.tpst01,
            title: this.UpdateData.tpst04,
            name: this.UpdateData.tpst03,
            color: this.UpdateData.tpst07,
          };
          EditTempInfo(params).then((res) => {
            //(res, "1");
            if (res.Code == 1) {
              this.$message({
                type: "success",
                message: "修改成功",
              });
              this.editor1 = false;
              this.getData();
            }
          });
          for (let i = 0; i < this.UpdateData.list.length; i++) {
            let Updatas = JSON.stringify({
              tslk01: this.UpdateData.list[i].tslk01,
              tslk02: this.UpdateData.list[i].tslk02,
              tslk03: this.UpdateData.list[i].tslk03,
              tslk04: this.UpdateData.list[i].tslk04,
              tslk05: this.UpdateData.list[i].tslk05,
            });
            EditTempsetLink({ model: Updatas }).then((res) => {
              //(res, "2");
            });
          }
        } else {
          this.$message({
            type: "warning",
            message: "表单填写有误",
          });
          return false;
        }
      });
    },
    // 获取所有数据
    getData() {
      this.loading = true;
      let params = {
        xid: localStorage.getItem("xid"),
        pageIndex: this.pagenum,
        pageSize: this.pagesize,
      };
      GetTempsetList({ params }).then((res) => {
        //(res, "addSingle1-res");
        this.total = res.Data.total;
        this.singleList = res.Data.list;
        this.loading = false;
      });
    },
    // 新增确定按钮
    addform(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = JSON.stringify(this.addPostList);
          AddTempset({ model: params }).then((res) => {
            //(res, "addform");
            this.addSingle1 = false;
            if (res.Code == 1) {
              this.$message({
                type: "success",
                message: "新建成功",
              });
              this.getData();
              this.addPostList = this.$options.data.call(this).addPostList;
            } else {
              this.$message.error("新建失败");
            }
          });
        } else {
          this.$message({
            type: "warning",
            message: "表单填写有误",
          });
          return false;
        }
      });
    },
    // 删除字段
    removeUpdataList(row) {
      //(row);
      let params = {
        tlid: row.tslk01,
      };
      DelTempsetLink(params).then((res) => {
        if (res.Code == 1) {
          let params = {
            tid: this.UpdateData.tpst01,
          };
          GetTempSetInfo({ params }).then((res) => {
            this.UpdateData = res.Data;
          });
        }
      });
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-row {
  padding: 20px 20px 0px;
}
// 新增
.font-sz24 {
  font-size: 24px;
}
.width100 {
  width: 100%;
}
.mar-top20 {
  margin-top: 20;
}
.head-text {
  float: right;
  margin-top: -4px;
}
</style>
